(() => {
  const handleVideoPlayback = (element) => {
    const videos = element.querySelectorAll(".slideshow__video video");
    
    if (element.swiper && element.swiper.initialized) {
      videos.forEach(video => {
        if (video.closest(".swiper-slide-visible")) {
          video.play();
        } else {
          video.pause();
        }
      });
    } else if (element.closest('[data-slide-count="1"]')) {
      videos.forEach(video => {
        video.play();
      });
    }
  };

  const initializeSlideshow = (section) => {
    if (!section || !section.classList.contains("section-slideshow")) return;

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const slideshow = section.querySelector(".slideshow");
          if (!slideshow) return;

          const prevButton = slideshow.querySelector(".swiper-button-prev");
          const nextButton = slideshow.querySelector(".swiper-button-next");

          const swiperConfig = {
            speed: 800,
            autoHeight: false,
            allowTouchMove: true,
            watchSlidesProgress: true,
            preventInteractionOnTransition: true,
            spaceBetween: 30,
          };

          const updateColorScheme = (swiper) => {
            const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            const activeSlide = swiper.slides[swiper.activeIndex];
            let breakpoint = 0;
            let swiperWrapper;

            if (swiper.el.parentNode.classList.contains("slideshow__swiper--simple")) {
              swiperWrapper = swiper.el.parentNode;
              breakpoint = 990;
            }

            if (swiper.el.classList.contains("slideshow__swiper--overlay") || 
                swiper.el.classList.contains("slideshow__swiper--grid")) {
              breakpoint = 0;
            }

            const elements = [
              swiper.navigation.nextEl,
              swiper.navigation.prevEl,
              swiper.pagination.el,
              ...(swiperWrapper ? [swiperWrapper] : [])
            ];

            if (windowWidth >= breakpoint) {
              const colorScheme = activeSlide.dataset.colorScheme;
              elements.forEach(element => {
                if (element) {
                  let className = element.getAttribute("class");
                  className = className.replace(/color-background-\d+/g, "");
                  element.setAttribute("class", className);
                  element.classList.add(colorScheme);
                }
              });
            } else {
              elements.forEach(element => {
                if (element) {
                  let className = element.getAttribute("class");
                  className = className.replace(/color-background-\d+/g, "");
                  element.setAttribute("class", className);
                }
              });
            }
          };

          if (slideshow.getAttribute("data-autoplay") === "true") {
            swiperConfig.autoplay = { disableOnInteraction: true };
          }

          if (slideshow.getAttribute("data-pagination") === "true") {
            let desktopPagination = document.querySelector(".swiper-pagination");
            let mobilePagination = document.querySelector(".swiper-pagination-mobile");
        
            if (desktopPagination && mobilePagination) {
                // If both exist, apply both
                swiperConfig.pagination = {
                    el: [desktopPagination, mobilePagination],
                    type: "bullets",
                    clickable: true
                };
            } else if (desktopPagination) {
                // Only apply desktop pagination
                swiperConfig.pagination = {
                    el: desktopPagination,
                    type: "bullets",
                    clickable: true
                };
            } else if (mobilePagination) {
                // Only apply mobile pagination
                swiperConfig.pagination = {
                    el: mobilePagination,
                    type: "bullets",
                    clickable: true
                };
            }
        }
        
        

          if (slideshow.getAttribute("data-navigation") === "true") {
            swiperConfig.navigation = {
              nextEl: nextButton,
              prevEl: prevButton
            };
          }

          if (slideshow.getAttribute("data-parallax") === "true" && 
              slideshow.getAttribute("data-layout") !== "grid") {
            swiperConfig.parallax = true;
          }

          if (slideshow.getAttribute("data-enable-loop") === "true") {
            swiperConfig.loop = true;
          }

          if (slideshow.getAttribute("data-layout") === "grid") {
            swiperConfig.breakpoints = {
              750: { slidesPerView: "auto" }
            };
          }

          const slideCount = Number(slideshow.getAttribute("data-slide-count"));
          if (slideCount > 1) {
            const layout = slideshow.getAttribute("data-layout");

            if (layout === "simple") {
              const textSwiper = slideshow.querySelector(".slideshow__swiper--text");
              const mediaSwiper = slideshow.querySelector(".slideshow__swiper--media");

              if (textSwiper && mediaSwiper) {
                const textSwiperInstance = new Swiper(textSwiper, swiperConfig);
                const mediaSwiperInstance = new Swiper(mediaSwiper, {
                  ...swiperConfig,
                  autoplay: false,
                  pagination: false,
                  navigation: false,
                  parallax: false
                });

                textSwiperInstance.controller.control = mediaSwiperInstance;
                mediaSwiperInstance.controller.control = textSwiperInstance;

                updateColorScheme(textSwiperInstance);

                textSwiperInstance.on("beforeTransitionStart", function() {
                  updateColorScheme(this);
                });

                mediaSwiperInstance.on("beforeTransitionStart", function() {
                  updateColorScheme(textSwiperInstance);
                });

                mediaSwiperInstance.on("slideChange", function() {
                  handleVideoPlayback(mediaSwiper);
                });
              }
            } else if (layout === "overlay") {
              const overlaySwiper = slideshow.querySelector(".slideshow__swiper--overlay");
              
              if (overlaySwiper) {
                const overlaySwiperInstance = new Swiper(overlaySwiper, {
                  ...swiperConfig,
                  effect: "creative",
                  creativeEffect: {
                    prev: { translate: [0, 0, -400] },
                    next: { translate: ["100%", 0, 0] }
                  }
                });

                updateColorScheme(overlaySwiperInstance);

                overlaySwiperInstance.on("beforeTransitionStart", function() {
                  updateColorScheme(this);
                });

                overlaySwiperInstance.on("slideChange", function() {
                  handleVideoPlayback(overlaySwiper);
                });
              }
            } else if (layout === "grid") {
              const gridSwiper = slideshow.querySelector(".slideshow__swiper--grid");
              
              if (gridSwiper) {
                const gridSwiperInstance = new Swiper(gridSwiper, swiperConfig);

                updateColorScheme(gridSwiperInstance);

                gridSwiperInstance.on("beforeTransitionStart", function() {
                  updateColorScheme(this);
                });

                gridSwiperInstance.on("slideChange", function() {
                  handleVideoPlayback(gridSwiper);
                });
              }
            }
          }
        }
      });
    }).observe(section);
  };

  const handleSlideshowVisibility = (section) => {
    if (!section || !section.classList.contains("section-slideshow")) return;

    const slideshow = section.querySelector(".slideshow");
    let swiperElement;

    if (slideshow && slideshow.getAttribute("data-layout") === "simple") {
      swiperElement = section.querySelector(".slideshow__swiper--media");
    } else if (slideshow && slideshow.getAttribute("data-layout") === "overlay") {
      swiperElement = section.querySelector(".slideshow__swiper--overlay");
    } else if (slideshow && slideshow.getAttribute("data-layout") === "grid") {
      swiperElement = section.querySelector(".slideshow__swiper--grid");
    }

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (swiperElement) {
            handleVideoPlayback(swiperElement);
            if (swiperElement.swiper && slideshow.getAttribute("data-autoplay") === "true") {
              swiperElement.swiper.autoplay.resume();
            }
          }
        } else {
          if (swiperElement) {
            const pauseVideos = (element) => {
              const videos = element.querySelectorAll(".slideshow__video video");
              if (element.swiper && element.swiper.initialized) {
                videos.forEach(video => video.pause());
              } else if (element.closest('[data-slide-count="1"]')) {
                videos.forEach(video => video.play());
              }
            };

            pauseVideos(swiperElement);
            
            if (swiperElement.swiper && slideshow.getAttribute("data-autoplay") === "true") {
              swiperElement.swiper.autoplay.pause();
            }
          }
        }
      });
    }).observe(section);
  };

  // Initialize for current script's parent element
  initializeSlideshow(document.currentScript.parentElement);
  handleSlideshowVisibility(document.currentScript.parentElement);

  // Listen for Shopify section load events
  document.addEventListener("shopify:section:load", function(event) {
    initializeSlideshow(event.target);
    handleSlideshowVisibility(event.target);
  });
})();